import parse from 'html-react-parser';
const StripHTML = (str) => str.replace(/<\/?[^>]+(>|$)/g, "")
const StripParseHTML = (str) => parse(str.replace(/<\/?[^>]+(>|$)/g, ""))
const ParseHTML = (str) => parse(str)

export { StripHTML, StripParseHTML, ParseHTML }